































import Vue from 'vue';
export default Vue.extend({
    data() {
        return {
            total: 0
        };
    },
    created() {
        window.FRSToolV3.getOnMarketFundsCount().then((res: any) => {
            this.total = res.result;
        });
    },
    methods: {
        thousand(number: any) {
            return parseInt(number).toLocaleString();
        },
        GAcode(el: string) {
            if (typeof window.ActionAnalysisV2 !== 'undefined' && typeof el !== 'undefined') {
                window.ActionAnalysisV2.actClk(el);
            }
        }
    }
});
